<template>
    <div :class="['loader', { 'fixed-top vh-100 vw-100': backdrop }, { 'loader-backdrop': backdrop, show, fade }]">
        <div :class="backdrop ? 'fixed-center' : 'position-center' " :style="[{ 'z-index': isLoading ? 1071 : null }]">
            <slot name="default">
                <b-spinner
                    label="Loading..."
                    v-bind="{ variant, small }"
                    :style="[ spinnerContainerSize ]"
                    :class="`spinner-border${spinnerShortCutSize}`"
                    >
                </b-spinner>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading-view',
    props: {
        isLoading: {
            type: Boolean,
            required: true
        },
        variant: {
            type: String,
            required: false,
            default: (variantProp) => typeof variantProp === 'undefined' ? 'light' : variantProp
        },
        size: {
            type: String,
            required: false
        },
        spinnerSize: {
            type: Object,
            required: false,
            default: (spinnerSizeProp) => typeof spinnerSizeProp === 'undefined' ? {} : spinnerSizeProp
        },
        backdrop: {
            type: Boolean,
            required: false,
            default: (backdropProps) => typeof backdropProps === 'undefined' ? false : backdropProps
        },
        small: {
            type: Boolean,
            required: false
        }
    },
    data () {
        return {
            show: false,
            fade: true
        }
    },
    computed: {
        spinnerContainerSize () {
            if (!this.spinnerSize.width && this.spinnerSize.height) {
                return { height: this.spinnerSize.height, width: this.spinnerSize.height }
            } else if (this.spinnerSize.width && !this.spinnerSize.height) {
                return { height: this.spinnerSize.width, width: this.spinnerSize.width }
            } else if (this.spinnerSize.width !== this.spinnerSize.height) {
                return { height: this.spinnerSize.width, width: this.spinnerSize.width }
            } else {
                return this.spinnerSize
            }
        },
        spinnerShortCutSize () {
            return typeof this.size === 'undefined' ? null : `-${this.size}`
        }
    },
    watch: {
        isLoading: {
            immediate: true,
            handler (status) {
            if (typeof status !== 'undefined') {
                if (status) {
                        this.show = status
                        setTimeout(() => { this.fade = !status }, 300);
                    } else {
                        this.fade = !status
                        setTimeout(() => { this.show = status }, 500);
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.loader {
    display: none;
    opacity: 1;
    outline: 0;
    overflow: hidden;
    transition: opacity 0.3s linear;

    &-backdrop {
        background-color: rgba(30, 30, 30, 0.5);
        z-index: 0;

        &.show {
            z-index: 9999;
        }
    }

    &.fade {
        opacity: 0;
    }

    &.show {
        display: block;
    }
}
</style>